export default "__VITE_ASSET__79486b78__"